// 업무 바로가기
//
// store/index.js 가 이 조각들을 펼쳐 하나의 루트 스토어로 합친다.
// Vuex 의 modules 옵션이 아니라 "조각"인 이유: Vuex 는 namespaced 여부와 무관하게
// 모듈 state 를 모듈 이름 아래에 중첩시킨다. 진짜 모듈로 바꾸면 store.state.tasks 가
// store.state.tasks.tasks 가 되어 소비자 40곳을 전부 고쳐야 한다.
// 조각 합성은 동작이 100% 동일하면서 파일만 나눈다.
//
// 좌측 레일 · 더보기 · 바로가기 화면 세 곳이 같은 목록을 읽어서 state 에 둔다.
// 목록이 거의 안 바뀌므로 한 세션에 한 번만 받는다(quickLinksLoaded).

import http from '@/utils/http'

export const state = {
  quickLinks: [],
  quickLinksLoaded: false
}

export const mutations = {
  SET_QUICK_LINKS(state, links) {
    state.quickLinks = links
    state.quickLinksLoaded = true
  }
}

export const actions = {
  async fetchQuickLinks({ commit, state }, { force = false } = {}) {
    if (state.quickLinksLoaded && !force) return state.quickLinks
    const { data } = await http.get('/api/quick-links')
    commit('SET_QUICK_LINKS', data.links || [])
    return data.links || []
  },

  async saveQuickLink({ dispatch }, { id, payload }) {
    const { data } = id
      ? await http.put(`/api/quick-links/${id}`, payload)
      : await http.post('/api/quick-links', payload)
    await dispatch('fetchQuickLinks', { force: true })
    return data.link
  },

  async deleteQuickLink({ dispatch }, id) {
    await http.delete(`/api/quick-links/${id}`)
    await dispatch('fetchQuickLinks', { force: true })
  },

  /** items: [{ id, sortOrder, groupName? }] */
  async reorderQuickLinks({ commit }, items) {
    const { data } = await http.put('/api/quick-links/order', { items })
    commit('SET_QUICK_LINKS', data.links || [])
    return data.links || []
  }
}
